import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Presentation from '../../../../../logic/redux/presentation';
import { ScreenSize } from '../../../../../styles/screen-sizes';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MobileContainer = styled.div.attrs(() => ({}))<{ visible: boolean }>`
  max-height: ${(props) => (props.visible ? '500px' : '0px')};
  opacity: ${(props) => (props.visible ? '1' : '0')};
  transition: 0.5s;
  width: 100%;
  font-size: 12px;
  overflow: hidden;
  margin: ${(props) => (props.visible ? '10px' : '0px')}; 0px;
`;

const Anchor = styled.div`
  height: 0px;
  width: 100%;
  overflow: visible;
`;

const Container = styled.aside.attrs(() => ({}))<{ visible: boolean; yOffset: number }>`
  width: calc(100% - 40px);
  opacity: ${(props) => (props.visible ? '1' : '0')};
  transition: 0.5s;
  font-size: 12px;
  overflow: hidden;
  transform: translate(calc(100% + 80px), ${(props) => props.yOffset}px);
  background: var(--matt-bg-color);
  padding: 20px 30px;
`;

const ExchangeOrderFieldInfo = (props: {
  visible: boolean;
  children: JSX.Element | null;
  yOffset?: number;
}): JSX.Element => {
  const screenSize = useSelector(Presentation.select.selectScreenSize);
  const isInMobileMode = screenSize <= ScreenSize.SM;

  if (isInMobileMode) {
    return <MobileContainer visible={props.visible}>{props.children}</MobileContainer>;
  }

  return (
    <Anchor>
      <Container visible={props.visible} yOffset={props.yOffset || 0}>
        {props.children}
      </Container>
    </Anchor>
  );
};

export default ExchangeOrderFieldInfo;
